import { useEffect } from "react";
import { ResizeObserver } from "@juggle/resize-observer";
import type { Form } from "@/react/types/Form";

interface UseAdjustFormHeightProps {
  form?: Form | null;
  index: number;
  isModal: boolean;
}
export const useAdjustFormHeight = ({
  form,
  index,
  isModal,
}: UseAdjustFormHeightProps) => {
  useEffect(() => {
    if (!form || isModal) {
      return;
    }

    const formWrapperElement = document.getElementById(
      `form-wrapper-${form.uid}-${index}`,
    );

    if (!formWrapperElement) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      const wrapperHeight = formWrapperElement.scrollHeight;
      // eslint-disable-next-line sonarjs/post-message -- Disabled for plugin version update. Fix when possible.
      window.parent.postMessage(
        {
          type: "resize",
          formUid: form.uid,
          formIndex: index,
          height: `${wrapperHeight}px`,
        },
        "*",
      );
    });

    resizeObserver.observe(formWrapperElement);
    return () => {
      resizeObserver.disconnect();
    };
  }, [form, index, isModal]);

  return null;
};
